export default 'fonts/a9fc1a44140b2271fc67f0f608161314.ttf';